import React from 'react';
import parse from "html-react-parser";


export const topicsColumn = {
    //default static first column
    title: '',
    dataIndex: 'name',
    key: 'name',
    fixed: 'left',
    width: 200,
    isStatic: true,
    render: (str, record) => (

        <>
            {/* <Tooltip placement="topLeft" title={str}> */}
            {parse(str)}
            {/* </Tooltip> */}
        </>
    ),
}

export const responsesColumn = {
    //default second column with title as organization name
    title: <div class="heatmap-text-block heatmap-bolder"><p>Overall</p></div>,
    dataIndex: 'score',
    key: 'score',
    isStatic: true,
    isResponses: true
}

export const DUMMY_TOPICS = [
    'Engagement',
    'Diversity',
    'Communication',
    'Management',
    'Leadership',
    'Change Readiness',
    'Need for Change',
    'Wellness',
    'Employees',
    'Agility'
]

export const DUMMY_QUESTIONS = [
    'What is going well?',
    'What can be improved?',
    'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    `Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
]

export const  RESPONSES = 'Responses';
export const HEATMAP_MESSAGE = (selectedOptions) => "Showing " + selectedOptions + " scores"

export const HEATMAP_OPTIONS = {
    favourable: 'favourable',
    neutral: 'neutral',
    unFavourable: 'unFavourable'
}

export const HEATMAP_MESSAGE_OPTIONS = {
    favourable: 'favorable',
    neutral: 'neutral',
    unFavourable: 'unfavorable'
}

export const HYPHEN = "-"
export const NO_DATA_MESSAGE = "There were not enough responses to show data"
export const NON_CHANGEABLE_KEYS_FOR_DOWNLOAD = ["score", 'name', 'key', 'children']
export const DISPLAY_COLOUR_LOGIC_DELTA = "delta"
export const DISPLAY_COLOUR_LOGIC_CUSTOM_THRESHOLD = "customThreshold"

export const HEATMAP_IMAGE_DOWNLOAD_ID = {
    "managerHeatmap": 1,
    "heatmap-grid": 0,
    "trendheatmap-grid": 2
}

export const HEATMAP_SHEET_NAMES = {
    0: "Category",
    1: "Subcategory",
    2: "Behaviors"
}